import { cn } from "@/lib/utils";
import { type HTMLInputTypeAttribute } from "react";

type InputProps = {
  type?: HTMLInputTypeAttribute;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  min?: string;
  max?: string;
  className?: string;
  disabled?: boolean;
  placeholder?: string;
  name?: string;
  id?: string;
};

export function Input({
  type = "text",
  value,
  onChange,
  min,
  max,
  className,
  disabled,
  placeholder,
  name,
  id,
}: InputProps) {
  return (
    <input
      type={type}
      value={value}
      onChange={onChange}
      min={min}
      max={max}
      disabled={disabled}
      placeholder={placeholder}
      name={name}
      id={id}
      className={cn(
        "w-full rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-dark outline-none transition focus:border-primary disabled:cursor-default disabled:bg-gray-2 dark:border-dark-3 dark:bg-dark-2 dark:text-white dark:focus:border-primary",
        className
      )}
    />
  );
}
